import BaseService from './base.service';

class UserService extends BaseService{

    async getUsers() {
        try {
            const res = await fetch("/api/v1/users", {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json"
                }
                ,
                credentials: "same-origin"
            });
            //this.handleHttpErrors(res);
            if ( res.ok ) {
                const users = await res.json();
                for (let u of users) {
                    u.key = u._id;
                }
                return users;
            }
            return [];
        } catch (error) {
            console.error('Error:', error);
        }
    }

    async addUser(user) {
        /*const data={
            officeId: '5d903821f70ddd256c767338',
            firstName: 'Test',
            lastName: 'Test',
            email: 'test@test.com',
            username: 'test',
            password: 'welcome1',
            role: 'Administrator',
            purview: 'User',
            status: 'Active'};*/

        try {
            const res = await fetch('/api/v1/users', {//Use "/" for absolute path ex: http://localhost/offices http://localhost/users
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "same-origin",
                body: JSON.stringify(user)

            });
            if (res.ok === false) {
                throw new Error('Network response was not ok.');
            }
            const json = await res.json();
            console.log('Success:', JSON.stringify(json));
            return json;
        } catch (error) {
            console.error('Error:', error);
        }

    }

    async editUser(id, data) {
        /*const url='/users/5d9a55b9ce028e5e80a1caa4';
        const data={
            officeId: '5d903821f70ddd256c767338',
            firstName: 'Test2',
            lastName: 'Test',
            email: 'test@test.com',
            username: 'test',
            password: 'welcome1',
            role: 'Administrator',
            purview: 'User',
            status: 'Active'};*/

        try {
            const res = await fetch('/api/v1/users/' + id, {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "same-origin",
                body: JSON.stringify(data)

            });
            if (res.ok === false) {
                throw new Error('Network response was not ok.');
            }
            const json = await res.json();
            console.log('Success:', JSON.stringify(json));
            return json;
        } catch (error) {
            console.error('Error:', error);
        }

    }

    async getOffices() {
        try {
            const res = await fetch("/api/v1/users/offices", {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json"
                }
                ,
                credentials: "same-origin"
            });
            if (res.ok === false) {
                throw new Error('Network response was not ok.');
            }
            const offices = await res.json();
            return offices;
        } catch (error) {
            console.error('Error:', error);
        }
    }

    async getUser(id) {
        try {
            const res = await fetch("/api/v1/users/" + id, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json"
                }
                ,
                credentials: "same-origin"
            });
            if (res.ok === false) {
                throw new Error('Network response was not ok.');
            }
            const user = await res.json();
            return user;
        } catch (error) {
            console.error('Error:', error);
        }
    }

    async findUsername(username) {
        try {
            const res = await fetch("/api/v1/users/search/"+username, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json"
                }
                ,
                credentials: "same-origin"
            });
            if (res.ok === false) {
                throw new Error('Network response was not ok.');
            }
            const user = await res.json();
            return user;
        } catch (error) {
            console.error('Error:', error);
        }
    }

}

const userService = new UserService();
export default userService;


